import { onBeforeUnmount, watch } from 'vue';
import { useStore } from 'dashboard/composables/store';
import Auth from 'dashboard/api/auth';

const IDLE_TIMEOUT_MS = 15 * 60 * 1000;
const SUPER_ADMIN_ID = 1;
const ACTIVITY_EVENTS = [
  'mousemove',
  'mousedown',
  'keydown',
  'touchstart',
  'scroll',
  'click',
];

export function useIdleTimeout() {
  const store = useStore();
  let timer = null;
  let attached = false;

  const doLogout = () => {
    Auth.logout().catch(() => {
      window.location = '/';
    });
  };

  const reset = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(doLogout, IDLE_TIMEOUT_MS);
  };

  const attach = () => {
    if (attached) return;
    ACTIVITY_EVENTS.forEach(evt =>
      window.addEventListener(evt, reset, { passive: true })
    );
    attached = true;
    reset();
  };

  const detach = () => {
    if (!attached) return;
    ACTIVITY_EVENTS.forEach(evt => window.removeEventListener(evt, reset));
    attached = false;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  watch(
    () => store.getters.getCurrentUser?.id,
    id => {
      if (id && id !== SUPER_ADMIN_ID) attach();
      else detach();
    },
    { immediate: true }
  );

  onBeforeUnmount(() => detach());
}
